<template>
  <BaseCompletePage
    :content="getMPPICover"
    :sdnData="SDN_DATA_MPPI_LOCAL"
    :cardTitle="
      $vuetify.breakpoint.lgAndUp
        ? 'Your Mortgage Protection Insurance quote'
        : 'Your quote'
    "
    :showAllQuoteSummary="false"
    :useRetrievedPaymentInfo="false"
    dialogContentPremiumBreakdownSlot
    createStatementOfDemandsAndNeedsDescription="You have not yet created a statement of demands and needs."
  >
    <template v-slot:dialogContentPremiumBreakdown="slotProps">
      <MPPIPremiumBreakdownDialog
        :breakdown-model="slotProps.breakdownModel"
      ></MPPIPremiumBreakdownDialog>
    </template>
  </BaseCompletePage>
</template>

<script>
// SDN dependencies
import { SDN_DATA_MPPI } from "@/constants/sdn.constants";

import BaseCompletePage from "@/views/BaseCompletePage.vue";
import MPPIPremiumBreakdownDialog from "@/components/QuoteResult/MPPIPremiumBreakdownDialog.vue";

import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

export default {
  name: "CompletePage",
  components: {
    BaseCompletePage,
    MPPIPremiumBreakdownDialog,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getMPPICover"]),
    SDN_DATA_MPPI_LOCAL() {
      return SDN_DATA_MPPI.map((sdnSection) => {
        return {
          ...sdnSection,
          sdnItems: sdnSection.sdnItems.filter((item) => {
            // Include items with an empty or undefined displayRules array
            if (!item.displayRules) return true;

            // Include items where at least one rule matches the conditions
            return item.displayRules.some((rule) => {
              //Include item if only type matches
              if (
                rule.type === this.getMPPICover.type &&
                !rule.benefitPeriod &&
                !rule.disabilityQualificationPeriod &&
                !rule.disabilityQualificationType &&
                !rule.unemploymentQualificationPeriod &&
                !rule.unemploymentQualificationType
              ) {
                return true;
              }

              //Include item if only type and disabilityQualificationType matches
              if (
                rule.type === this.getMPPICover.type &&
                !rule.unemploymentQualificationType &&
                rule.disabilityQualificationType ===
                  this.getMPPICover.disabilityQualificationType &&
                !rule.benefitPeriod &&
                !rule.disabilityQualificationPeriod &&
                !rule.unemploymentQualificationPeriod
              ) {
                return true;
              }

              //Include item if only type, unemploymentQualificationType and unemploymentQualificationPeriod matches
              if (
                rule.type === this.getMPPICover.type &&
                !rule.benefitPeriod &&
                !rule.disabilityQualificationPeriod &&
                !rule.disabilityQualificationType &&
                rule.unemploymentQualificationPeriod ===
                  this.getMPPICover.unemploymentQualificationPeriod &&
                rule.unemploymentQualificationType ===
                  this.getMPPICover.unemploymentQualificationType
              ) {
                return true;
              }

              //Include item if only type, disabilityQualificationType and disabilityQualificationPeriod matches
              if (
                rule.type === this.getMPPICover.type &&
                !rule.benefitPeriod &&
                rule.disabilityQualificationPeriod ===
                  this.getMPPICover.disabilityQualificationPeriod &&
                rule.disabilityQualificationType ===
                  this.getMPPICover.disabilityQualificationType &&
                !rule.unemploymentQualificationPeriod &&
                !rule.unemploymentQualificationType
              ) {
                return true;
              }

              //Include item if only type and benefitPeriod matches
              if (
                rule.type === this.getMPPICover.type &&
                rule.benefitPeriod === this.getMPPICover.benefitPeriod &&
                !rule.disabilityQualificationPeriod &&
                !rule.disabilityQualificationType &&
                !rule.unemploymentQualificationPeriod &&
                !rule.unemploymentQualificationType
              ) {
                return true;
              }

              //Include item if only type and disabilityQualificationType matches
              if (
                rule.type === this.getMPPICover.type &&
                !rule.benefitPeriod &&
                !rule.disabilityQualificationPeriod &&
                !rule.disabilityQualificationType &&
                !rule.unemploymentQualificationPeriod &&
                rule.unemploymentQualificationType ===
                  this.getMPPICover.unemploymentQualificationType
              ) {
                return true;
              }
            });
          }),
        };
      });
    },
  },
  data() {
    return {
      SDN_DATA_MPPI,
    };
  },
};
</script>
